// extracted by mini-css-extract-plugin
module.exports = {"container":"SaltVoteCount_container__xdXmt","milestone":"SaltVoteCount_milestone__K4Yux","milestone-achieved":"SaltVoteCount_milestone-achieved__1uwW_"};